<div class="{{paddingClass}}" *ngIf="accordionPanel.open">
  <ng-content></ng-content>
</div>
